module.exports = __webpack_public_path__ + "img/why-us-banner.7d6171f1.svg";